import React from "react";

import { Breadcrumb } from "antd";

import { goTo, useAppType, useNavigate } from "utils";

import { Flex, Icon, IconSizes } from "components";

export type Crumb = {
  name: string;
  link?: string;
};

export type BreadcrumbsProps = {
  items: Crumb[];
  className?: string;
  dataTestId?: string;
  size?: IconSizes;
  additionalData?: React.ReactNode;
};

export const Breadcrumbs = ({ items, className, dataTestId, size = "s", additionalData }: BreadcrumbsProps) => {
  const navigate = useNavigate();
  const appType = useAppType();

  const itemList = appType.app || appType.mobile ? items.slice(-2) : items;

  const getBreadcrumb = (item: Crumb, idx: number) => (
    <span
      // @ts-expect-error test
      onClick={item.link ? () => goTo(null, navigate, item.link) : null}
      className={`breadcrumb ${item.link ? `pointer grey-text paragraph-${size}` : `paragraph-${size}`} ${idx === 0 ? "first-breadcrumb" : ""} 
        ${idx === itemList.length - 1 ? "last-breadcrumb" : ""}`}
    >
      {item.name}
    </span>
  );

  return (
    <div className="breadcrumbs-container" data-testid={dataTestId}>
      <Flex align="center" gap={"0.5rem"}>
        <Breadcrumb
          className={className}
          // @ts-expect-error test
          items={
            itemList?.length
              ? itemList.map((item, idx) => {
                  if (idx === itemList.length - 1 && additionalData)
                    return {
                      title: (
                        <Flex align="center" gap="0.5rem">
                          {getBreadcrumb(item, idx)}
                        </Flex>
                      ),
                    };
                  return { title: getBreadcrumb(item, idx) };
                })
              : null
          }
          separator={<Icon className="icon" iconName="tabler/chevron-right" size={size} alt="" />}
        />
        {additionalData}
      </Flex>
    </div>
  );
};
